/**
 * 登录相关 API
 */
import { request } from './request'

/**
 * 用户登录
 * @param {string} username - 用户名
 * @param {string} password - 密码
 */
export function login(username, password) {
  return request('/api/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
    skipAuth: true
  })
}

/**
 * 钉钉免登（无需认证）
 * 通过钉钉免登码获取用户信息，与本地数据库 ding_id 匹配
 * @param {string} authCode - 钉钉免登码
 * @returns {Promise<{ success, token, user_info, message }>}
 */
export function dingtalkLogin(authCode) {
  return request('/api/dingtalk-login', {
    method: 'POST',
    body: JSON.stringify({ auth_code: authCode }),
    skipAuth: true
  })
}

/**
 * 获取当前登录用户导航
 * @returns {Promise<{ success, data: { role, portal, sections } }>}
 */
export function getUserNavigation(options = {}) {
  return request('/api/user-navigation', options)
}

/**
 * 用户登出
 */
export function logout() {
  return request('/api/logout', {
    method: 'POST',
    skip401Redirect: true,
    silent: true
  })
}
